import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import * as types from '../../../constants/actionTypes';
import PropTypes from 'prop-types'
import Drawer from '../../Common/Drawer/Drawer';
import LoadingIndicator from '../../Common/LoadingIndicator/LoadingIndicator';
import InputText from '../../Common/InputText';
import './EditGoalGroupDrawer.scss';
import Notification from '../../Common/Notification';

export class EditGoalGroupDrawer extends Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            isSaving: false,
            users: [],
            selectedUser: "",
            searchTerm: "",
            isFormValid: true,
            isSearching: false
        }
    }

    search = async () => {
        if(this.state.searchTerm.length <= 1){
            return;
        }
        try {
            this.setState({ isSearching: true });
            const response = await this.props.locationTaskActions.searchResponsibleUsers([this.props.locationKey], this.state.searchTerm);
            if (response.type === types.SEARCH_LOCATION_TASK_RESPONSIBLE_USERS_SUCCESS) {

                this.setState({ users: response.payload.users});

            } else if (response.type === types.SEARCH_LOCATION_TASK_RESPONSIBLE_USERS_FAILURE) {
                Notification("error", "Error", response.payload.message);
            }
        } catch (error) {
            Notification("error", "Error", error);
        } finally {
            this.setState({ isSearching: false });
        }
    }

    updateSearchTerm = (e) => {
        this.setState({ searchTerm: e.currentTarget.value});
    }

    selectUser = (e) => {
        const selectedUser = this.state.users.find(m => m.id === parseInt(e.currentTarget.value));
        this.setState({ selectedUser: selectedUser });
    }

    onSave = async () => {
        if(!this.state.selectedUser){
            this.setState({ isFormValid: false });
            return;
        }

        try {
            const response = await this.props.locationContactActions.create(this.props.locationKey, this.state.selectedUser.id);
            if (response.type === types.CREATE_LOCATION_CONTACT_SUCCESS) {

                Notification("success", "", "Location Contact Added");
                this.props.onComplete();

            } else if (response.type === types.CREATE_LOCATION_CONTACT_FAILURE) {
                Notification("error", "Error", response.payload.message);
            }
        } catch (error) {
            Notification("error", "Error", error);
        }
    }

    render() {

        return (
            <Drawer isOpen={true} isWide={false} title='Add Location Contact'
                onSaveClick={this.onSave}
                saveText='Save'
                onCancelClick={this.props.onCancel}>

                <Fragment>
                    <InputText
                        type="text"
                        name="search"
                        label="User Search"
                        placeholder="Type a name here and press enter to search"
                        value={this.state.searchTerm}
                        onChange={this.updateSearchTerm}
                        onKeyUp={this.search}
                        maxLength={20}
                    />

                    <LoadingIndicator isLoading={this.state.isSearching}>
                        <form noValidate className={this.state.isFormValid ? "" : "was-validated"}>
                            <div className="mb-3">
                                <span className="has-float-label">
                                    <select name="searchResults" size={10} className="form-control user-select" onClick={this.selectUser} required={true}>
                                        {this.state.users.map(user =>
                                            <option key={user.id} value={user.id}>{user.name}</option>
                                        )}
                                    </select>
                                    <label htmlFor="searchResults">Search Results</label>
                                    <div className="invalid-feedback">Choose a User</div>
                                </span>
                            </div> 
                        </form>                
                    </LoadingIndicator>  
                </Fragment>

            </Drawer>
        )
    }
}

EditGoalGroupDrawer.propTypes = {
    locationTaskActions: PropTypes.object.isRequired,
    locationContactActions: PropTypes.object.isRequired,
    onComplete: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    locationKey: PropTypes.string.isRequired
};


export default connect(null, null)(EditGoalGroupDrawer);